import React from 'react';
import { Article } from '../../types';
import { useLanguage } from '../../contexts/LanguageContext';
import './BlogCard.css';

interface BlogCardProps {
  article: Article;
  onClick: () => void;
  showStatus?: boolean;
}

const BlogCard: React.FC<BlogCardProps> = ({ article, onClick, showStatus = false }) => {
  const { t } = useLanguage();

  const formatDate = (dateString: string | undefined) => {
    if (!dateString) return '';
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  return (
    <div className="blog-card" onClick={onClick}>
      {article.featured_image && (
        <div className="blog-card-image">
          <img src={article.featured_image} alt={article.title} />
        </div>
      )}
      <div className="blog-card-content">
        {showStatus && (
          <span className={`blog-card-status ${article.status}`}>
            {article.status === 'draft' ? t('blog.draft') : t('blog.published')}
          </span>
        )}
        <h3 className="blog-card-title">{article.title}</h3>
        {article.excerpt && (
          <p className="blog-card-excerpt">{article.excerpt}</p>
        )}
        <div className="blog-card-meta">
          <span className="blog-card-author">
            {t('blog.by')} {article.author.first_name} {article.author.last_name}
          </span>
          <span className="blog-card-date">
            {formatDate(article.published_at || article.created_at)}
          </span>
        </div>
        <span className="blog-card-read-more">{t('blog.readMore')} →</span>
      </div>
    </div>
  );
};

export default BlogCard;
